/**
 * QuoteNextActionChip — operator next step (mock-style action pill).
 */

import React from "react";
import { Chip } from "@mui/material";
import { getQuoteNextAction } from "../services/quoteOperationalStatus.js";

const ACTION_SX = {
  generate_pdf: {
    bgcolor: "rgba(96,125,139,0.12)",
    color: "#455a64",
    borderColor: "rgba(96,125,139,0.35)",
  },
  send_quote: {
    bgcolor: "rgba(46,125,50,0.12)",
    color: "#1b5e20",
    borderColor: "rgba(46,125,50,0.4)",
  },
  follow_up: {
    bgcolor: "rgba(25,118,210,0.12)",
    color: "#0d47a1",
    borderColor: "rgba(25,118,210,0.35)",
  },
  respond: {
    bgcolor: "rgba(0,151,167,0.12)",
    color: "#006064",
    borderColor: "rgba(0,151,167,0.35)",
  },
  check_payment: {
    bgcolor: "rgba(237,108,2,0.12)",
    color: "#e65100",
    borderColor: "rgba(237,108,2,0.4)",
  },
  confirm_order: {
    bgcolor: "rgba(46,125,50,0.14)",
    color: "#1b5e20",
    borderColor: "rgba(46,125,50,0.4)",
  },
  request_deposit: {
    bgcolor: "rgba(237,108,2,0.12)",
    color: "#e65100",
    borderColor: "rgba(237,108,2,0.4)",
  },
  view_revision: {
    bgcolor: "rgba(158,158,158,0.12)",
    color: "#616161",
    borderColor: "rgba(158,158,158,0.35)",
  },
  renew: {
    bgcolor: "rgba(158,158,158,0.12)",
    color: "#616161",
    borderColor: "rgba(158,158,158,0.35)",
  },
  view_order: {
    bgcolor: "rgba(49,27,146,0.12)",
    color: "#311b92",
    borderColor: "rgba(49,27,146,0.35)",
  },
  none: {
    bgcolor: "transparent",
    color: "#9e9e9e",
    borderColor: "rgba(158,158,158,0.35)",
  },
  review: {
    bgcolor: "rgba(158,158,158,0.12)",
    color: "#616161",
    borderColor: "rgba(158,158,158,0.35)",
  },
};

const QuoteNextActionChip = ({ quote, size = "small" }) => {
  const action = getQuoteNextAction(quote);
  if (!action || action.key === "none") {
    return (
      <Chip
        label="—"
        size={size}
        variant="outlined"
        sx={{ fontWeight: 500, ...ACTION_SX.none }}
      />
    );
  }

  return (
    <Chip
      label={action.label}
      size={size}
      variant="outlined"
      sx={{
        fontWeight: 700,
        borderRadius: 2,
        ...ACTION_SX[action.key],
      }}
      data-testid="quote-next-action"
    />
  );
};

export default QuoteNextActionChip;
